import React from 'react'

import { formatCurrency } from 'utils/formatters'
import { padLeft } from 'utils'
import Card from 'common/Card'
import ReactTable from 'common/ReactTable'
import Ribbon from 'common/Ribbon'

import PurchaseInvoice from './PurchaseInvoice'

export default ({ resource, orderItem, caseCurrency }) => {
  const { order, supplier, totals, purchaseInvoices } = orderItem
  const piItems = purchaseInvoices || []
  const orderLines = order.lines

  const columns = React.useMemo(
    () => [
      {
        Header: resource.Description,
        accessor: 'description',
        headerClassName: 'col',
        className: 'col',
        footerClassName: 'col text-end fw-bold',
        Cell: ({ value, row }) =>
          row.isCreditNotes ? (
            <em className="text-muted">{resource.CreditNotes}</em>
          ) : (
            <span title={value} className="word-break-break-word white-space-normal">
              {value}
            </span>
          ),
        Footer: () => `${resource.Total}:`,
      },
      {
        Header: resource.PoAmount,
        accessor: 'poLinePrice.value',
        headerClassName: 'col-2 text-end',
        className: 'col-2 border-left text-end border-start',
        footerClassName: 'col-2 border-left text-end fw-bold border-start',
        Cell: ({ value }) => <span>{value ? formatCurrency(value, undefined, caseCurrency.currencySymbol) : '-'}</span>,
        Footer: () => formatCurrency(totals.poTotal.value, undefined, caseCurrency.currencySymbol),
      },
      {
        Header: resource.OrderAmount,
        accessor: 'orderLinePrice.value',
        headerClassName: 'col-2 text-end',
        className: 'col-2 border-left text-end border-start',
        footerClassName: 'col-2 border-left text-end fw-bold border-start',
        Cell: ({ value }) => <span>{value ? formatCurrency(value, undefined, caseCurrency.currencySymbol) : '-'}</span>,
        Footer: () => formatCurrency(totals.orderTotal.value, undefined, caseCurrency.currencySymbol),
      },
      {
        Header: resource.PiAmount,
        accessor: 'piLinesTotal.value',
        headerClassName: 'col-2 text-end',
        className: 'col-2 border-left text-end border-start',
        footerClassName: 'col-2 border-left text-end fw-bold border-start',
        Cell: ({ value, row }) =>
          row.isCreditNotes ? (
            <span>{totals.pcnTotal ? formatCurrency(totals.pcnTotal.value, undefined, caseCurrency.currencySymbol) : '-'}</span>
          ) : (
            <span>{value ? formatCurrency(value, undefined, caseCurrency.currencySymbol) : '-'}</span>
          ),
        Footer: () => (
          <span className="text-end fw-bold ">{totals.piTotal ? formatCurrency(totals.piTotal.value, undefined, caseCurrency.currencySymbol) : '-'}</span>
        ),
      },
    ],
    []
  )

  React.useEffect(() => {
    orderLines.push({ isCreditNotes: true })
  }, [])

  return (
    <React.Fragment>
      <Card
        outline
        title={
          <div className="mb-lg-0 mb-1 white-space-break-spaces text-lg-start text-center">
            <strong>{`${resource.Order} ${padLeft(order.documentIndex, 1)}`}</strong> - {resource.Supplier}:{' '}
            {supplier.name}
          </div>
        }
        titleClassName="white-space-nowrap flex-lg-row flex-column"
        className="invoice-order-block-item margin-bot-20"
      >
        {!!order.cancelReason && (
          <Ribbon color="danger" right={false}>
            {resource.Cancelled}
          </Ribbon>
        )}
        <ReactTable columns={columns} data={orderLines} showFooter responsive />
      </Card>
      {!!piItems.length && <PurchaseInvoice resource={resource} piItems={piItems} caseCurrency={caseCurrency}/>}
    </React.Fragment>
  )
}
